var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 9.5,
    r: 3,
    stroke: "#022B54"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 18C16.5 15.2386 14.5376 12.5 11.5 12.5C8.46243 12.5 6.5 15.2386 6.5 18",
    stroke: "#022B54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.5C14.5 13.5 13.8146 15.5 11.5 15.5C9.18538 15.5 8.5 13.5 8.5 13.5",
    stroke: "#022B54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.e7f3556ca9e2908a1e6c756526f17441.svg";
export { ForwardRef as ReactComponent };